/* eslint-disable complexity */
import React from 'react'
import { s, styled } from '@vega/styled'
import { noop, isEmpty } from '@neo/ramda-extra'
import { LoaderWithLabel } from '@vega/components'
import { useDispatch } from 'react-redux'
import { setInspectedPropertyId } from 'modules/property'
import { PropertyDetailsCard } from './PropertyDetailsCard'

const Container = styled.div(s('flex flex-column flex-1'))
const Grid = styled.div(s('h-full mb-8 px-6'), {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(400px, 1fr))',
  columnGap: 20,
  rowGap: 24,
})

const EmptyPropertiesContainer = styled.div(
  s('flex flex-column flex-1 justify-center items-center', {
    transform: 'translateY(-15px)',
  })
)

const GridView = ({
  properties = [],
  isLoading = false,
  openReviewPropertyModal = noop,
}) => {
  const dispatch = useDispatch()

  const onReviewBtnClicked = (event, propertyId) => {
    event.stopPropagation()
    dispatch(setInspectedPropertyId(propertyId))
    openReviewPropertyModal()
  }

  const isFirstTimeFetchingProperties = isLoading && isEmpty(properties)
  const noPropertiesFound = !isLoading && isEmpty(properties)

  if (isFirstTimeFetchingProperties)
    return (
      <LoaderWithLabel
        style={{ marginTop: 220 }}
        labelStyle={s('mt-6 text-base')}
        label="Fetching properties"
      />
    )

  if (noPropertiesFound)
    return (
      <EmptyPropertiesContainer>
        <h2 style={s('my-0 mb-3 text-green-700 font-normal text-3xl')}>
          No properties yet
        </h2>
        <span style={s('text-grey-600 text-lg')}>Let&apos;s add them in</span>
      </EmptyPropertiesContainer>
    )

  return (
    <Container>
      <Grid>
        {properties.map(
          ({
            id,
            address,
            imageSrc,
            details = {},
            valuation = {},
            createdBy = {},
            isDeleted,
          }) => (
            <PropertyDetailsCard
              key={id}
              imageSrc={imageSrc}
              estimatedValue={valuation?.estimatedValue}
              address={address}
              numOfBedrooms={details?.numOfBedrooms}
              numOfBathrooms={details?.numOfBathrooms}
              numOfCarparks={details?.numOfGarages}
              floorArea={details?.floorArea}
              landArea={details?.landArea}
              createdBy={createdBy}
              isDeleted={isDeleted}
              onReviewBtnClicked={(e) => onReviewBtnClicked(e, id)}
            />
          )
        )}
      </Grid>
    </Container>
  )
}

export { GridView }
